module.exports = __webpack_public_path__ + "static/media/sn-bt-background.31c31ec2.jpg";